var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{staticClass:"white",attrs:{"label":"Type","items":_vm.datasetType,"item-text":"name","item-value":"value"},model:{value:(_vm.inputVal),callback:function ($$v) {_vm.inputVal=$$v},expression:"inputVal"}})}
var staticRenderFns = []

export { render, staticRenderFns }